import React from 'react';
import PropTypes from 'prop-types';

const Status = ({ asset }) => {
  const statusMap = {
    approved: bfTranslate('Approved'),
    pending_approval: bfTranslate('Pending approval'),
    unpublished: bfTranslate('Draft'),
    expired: bfTranslate('Expired')
  };

  const { availability, availability_end, availability_start } = asset.attributes;
  let statusModifier;

  if (availability !== 'unpublished' && availability !== 'expired') {
    if (availability_start && new Date(availability_start) > new Date()) {
      statusModifier = bfTranslate(', unpublished');
    }

    if (availability_end && new Date(availability_end) < new Date()) {
      statusModifier = bfTranslate(', expired');
    }
  }

  return (
    <div className="availability-row status-container">
      <h4>{bfTranslate('Current status')}:</h4>
      <p className="status">{statusMap[availability] || bfTranslate('Available')}{statusModifier}</p>
    </div>
  );
};

Status.propTypes = {
  asset: PropTypes.shape({
    attributes: PropTypes.shape({
      availability: PropTypes.string,
      availability_end: PropTypes.string,
      availability_start: PropTypes.string,
    })
  }).isRequired,
};

export default Status;
